/**
 * Created by d.penning on 04.10.2017.
 */
import { combineReducers } from 'redux'

// reducers
import timings from './timings'
import playerStats from './playerStats'
import phases from './phases'
import config from './config'
import bookmakerOptions from './bookmakerOptions'
import staticTexts from './staticTexts';
import translations from './translations';
import gui from './gui';
import statsTeamVersusRecent from './statsTeamVersusRecent';
import statsRanking from './statsRanking';
import statsTeamLastX from './statsTeamLastX';
import statsPlayerAggregate from './statsPlayerAggregate';
import lastAction from './lastAction';
import matches from './matches';
import odds from './odds';
import statsOverall from './statsOverall';
import focusMatch from './focusMatch';
import pauseResume from './pauseResume';

export default combineReducers({
  timings,
  playerStats,
  phases,
  config,
  bookmakerOptions,
  staticTexts,
  translations,
  gui,
  statsTeamVersusRecent,
  statsRanking,
  statsTeamLastX,
  statsPlayerAggregate,
  lastAction,
  matches,
  odds,
  statsOverall,
  focusMatch,
  pauseResume
})
